// id of the root div contain all widget, used as root selector in main.sass
var CONTAINER_ID = 'subiz'

var sb = require('@sb/util')
import store from '@sb/store'
const browser = require('bowser').getParser(window.navigator.userAgent).parsedResult

const loadWidget = () => import(/*webpackChunkName: "widget" */ './Widget.js')

import Vue from 'vue'

import {directive as onClickaway} from 'vue-clickaway'
Vue.config.productionTip = false
Vue.directive('clickaway', onClickaway)

import * as com from '../components/index.js'
Vue.component('Spinner', com.Spinner)
Vue.component('Time', com.Time)
Vue.component('Emoji', com.Emoji)

// chat button is alway shown, so don't bother dynamic loading it
import ChatButton from './ChatButton.js'

var Widget = undefined

var main = new Vue({
	name: 'controller',
	i18n: store.i18n,

	data() {
		return {
			isShowWidget: false,
			widgetView: '',
			widgetConvoId: '',
		}
	},

	mounted() {
		store.onConvoEvent(this, _ => this.checkExpand())
		store.onUpdate(this, _ => this.checkExpand())

		if (store.matchIsOpen() && store.matchLastview().view) {
			main.showWidget(Object.assign({}, store.matchLastview().opts, {view: store.matchLastview().view}))
		} else {
			main.hideWidget()
		}
	},

	render() {
		if (sb.isUserBanned(store.matchUser())) return null

		var $widget = null
		if (Widget)
			$widget = (
				<Widget
					view={this.widgetView}
					cid={this.widgetConvoId}
					isShow={this.isShowWidget}
					vOn:close={this.onWidgetClose}
					vOn:go={this.showWidget}
				/>
			)
		var cls = browser.platform.type === 'mobile' ? 'mobile' : 'desktop'
		return (
			<div id={CONTAINER_ID}>
				<div class={cls}>
					<ChatButton ref="button" isShow={!this.isShowWidget} vOn:click={this.showWidget} />
					{$widget}
				</div>
			</div>
		)
	},

	methods: {
		checkExpand() {
			// run on desktop environment only
			if (browser.platform.type === 'mobile') return

			// dont try to expand widget if user has already closed it
			if (store.matchHasManuallyClosed()) return

			let convoM = store.matchConvo('*')
			let redconvo = sb.find(convoM, convo => {
				let events = store.listEvents(convo.id)
				return !sb.isConvoSeen(store.matchUser().id, events)
			})
			if (!redconvo || !redconvo.id) return
			if (!this.isShowWidget) this.showWidget({view: 'chat', cid: redconvo.id})
		},

		async showWidget(p) {
			this.$refs.button.clearPreview()
			p = p || {}
			if (browser.platform.type === 'mobile') modifyViewport()

			this.widgetConvoId = p.cid
			this.widgetView = p.view
			store.setIsOpen(true)

			// lazy load widget
			if (!Widget) Widget = (await loadWidget()).default

			this.$forceUpdate()
			this.isShowWidget = true

			store.setLastview(this.widgetView, {cid: this.widgetConvoId})
		},

		hideWidget() {
			restoreViewport()
			store.setIsOpen(false)
			this.isShowWidget = false
		},

		onWidgetClose() {
			this.$refs.button.clearPreview()
			store.setHasManuallyClosed()
			this.hideWidget()
		},
	},
})

function restoreViewport() {
	// remove our viewport
	let metatag = document.getElementById('subiz-meta-viewport')
	if (metatag) metatag.remove()
}

function modifyViewport() {
	let metatag = document.createElement('meta')
	metatag.httpEquiv = 'X-UA-Compatible'
	metatag.name = 'viewport'
	metatag.id = 'subiz-meta-viewport'
	metatag.content = 'maximum-scale=1.0, user-scalable=no, width=device-width, initial-scale=1.0'
	document.getElementsByTagName('head')[0].appendChild(metatag)
}

var controller = {
	domGate: new sb.Gate(),

	async showWidget(view, opts) {
		await this.domGate.entry()
		main.showWidget(Object.assign({}, opts, {view}))
	},

	async hideWidget() {
		await this.domGate.entry()
		main.hideWidget()
	},

	async showConvo(id) {
		await this.domGate.entry()
		// force show chat or it will auto switch to form if enable
		main.showWidget({view: 'chat', cid: id})
	},

	// should make sure that store is ready before calling this function
	async mount() {
		// add google font
		var $link = document.createElement('link')
		$link.href = 'https://fonts.googleapis.com/css?family=Roboto:400,500&display=swap&subset=vietnamese'
		$link.rel = 'stylesheet'
		document.head.append($link)

		// add container to client site
		var $div = document.createElement('div')
		document.body.appendChild($div)
		main.$mount($div)

		this.domGate.open()
	},
}

window.addEventListener('keydown', e => {
	if (e.key === 'Escape') controller.hideWidget()
})

export default controller
